<template>
  <div class="gallery">

    <Carousel
      v-if="isMobile()"
      :items="photos"
      @onSelectItem="selectPhoto"
    />

    <!-- Masonry -->
    <Masonryc
      v-else
      :items="photos"
      @onSelectItem="selectPhoto"
    />

    <button 
      v-if="!isMobile() && photosLimit !== 0 && getAllPhotos.length > photosLimit"
      class="gallery__more-button" 
      @click="loadMorePhotos"
    >
      More Photos
    </button>
    <!-- End Masonry -->

    <HMTLightbox 
      :show="isLightbox"
      :index="photoIndex"
      :items="getAllPhotos"
      @onClose="toggleLightbox"
    />
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  import Masonryc from './components/Masonry';
  import Carousel from './components/Carousel';
  import HMTLightbox from '@/shared/components/Lightbox';
  import gaMixin from '@/shared/mixins/ga';
  import deviceMixin from '@/shared/mixins/device';

  export default {
    name: 'Gallery',
    mixins: [
      gaMixin,
      deviceMixin
    ],
    components: {
      Masonryc,
      Carousel,
      HMTLightbox
    },
    data () {
      return {
        photosLimit: 16,
        photoIndex: 0,
        isLightbox: false
      }
    },
    computed: {
      ...mapGetters('tour', ['getPhotosByLimit', 'getAllPhotos']),
      photos () {
        if (this.photosLimit > 0 && !this.isMobile()) {
          return this.getPhotosByLimit(this.photosLimit);
        }

        return this.getAllPhotos;
      }
    },
    methods: {
      loadMorePhotos () {
        this.photosLimit = 0;
      },
      selectPhoto (photoIndex) {
        this.photoIndex = photoIndex;

        this.toggleLightbox();
        this.sendEventGA('Gallery', `Image ${photoIndex + 1}`, 'Selected');
      },
      toggleLightbox () {
        this.isLightbox = !this.isLightbox;
      }
    }
  };
</script>

<style lang="scss">
  @import '../../styles/variables.scss';

  .gallery {
    &__more-button {
      margin-top: 10px;
      padding: 20px 30px;
      border: none;
      border-radius: 2px;
      background-color: var(--gallery-button-bg-color);
      box-shadow: rgba(0, 0, 0, 0.3) 0px 1px 4px -1px;
      font-size: 16px;
      line-height: 1;
      color: #fff;
      text-transform: uppercase;
      outline: none;
      cursor: pointer;
      transition: background-color .2s ease-out;

      &:hover {
        background-color: var(--gallery-button-bg-hover-color);
      }
    }
  }
</style>
